











































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { sendToParent, platform, Bridge } from '@/common/bridge';
import { namespace } from 'vuex-class';
import { emitOpenMyRequest } from '@/common/eventBus';
import clickOutside from '@/directives/clickOutside';
import LanguageSelector from '@/components/LanguageSelector.vue';
import ManageConsentGA from '@/components/ManageConsentGA.vue';
import { LANGUAGES, SupportedLanguages } from '@/plugins/i18n';
import * as env from '@/common/environment';
import LanguageIcon from './icons/LangaugeIcon.vue';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';
import { analytics, syncLogs, COMPONENT_EVENTS } from '@/common/logs';

const userModule = namespace('user');
const chatModule = namespace('chat');
const analyticsConsentModule = namespace('analyticsConsent');

enum ActionEnum {
  MyRequest,
  Login,
  NotLoginWeb
}

@Component({
  components: { LanguageIcon, ManageConsentGA },
  directives: {
    clickOutside,
    trackClick,
  },
})
export default class Header extends Vue {
  $refs!: {
    nav: HTMLDivElement;
  };
  @Prop({ default: '' }) readonly title!: string;
  @Prop({ default: () => {} }) readonly backCallback!: Function;
  @Prop({ default: false }) readonly isInlive!: boolean; // only show when LIveChat
  @Prop(Boolean) readonly hideAction!: boolean;
  @Prop({ default: () => {} }) readonly endChatCallback!: Function;
  @Prop(Boolean) readonly isChatScreen!: boolean;
  @Prop(Boolean) readonly hideLanguageSelector!: boolean;
  @Prop(Boolean) readonly isActiveConversationSelected!: boolean;
  @Prop(Boolean) readonly hideMyRequests!: boolean;
  @Prop(Boolean) readonly forceHideBack!: boolean;
  @Prop(Number) readonly ticketId!: number;
  @Prop(String) readonly trackEventContext!: string;

  @userModule.State('isLogin') isLogin!: boolean;
  @userModule.State('directLink') directLink!: boolean;
  @chatModule.Mutation('updateNewMessage') updateNewMessage!: Function;

  @userModule.State('hideLoginButton') hideLoginButton!: boolean;
  @analyticsConsentModule.Getter('showManageConsentButton') showManageConsentButton!: boolean;

  readonly BTN_EVTS = BTN_EVTS;
  readonly COMPONENT_EVENTS = COMPONENT_EVENTS;

  showDropdown = false;
  showManageConsentModel = false;
  remainOpen= true;
  platform = platform;
  ActionEnum = ActionEnum;
  navHeight = 0;

  get showLanguageSelector () {
    return !this.hideLanguageSelector && env.get('showLanguageSelector');
  }

  get localeName () {
    const locale = this.$i18n.locale as SupportedLanguages;

    if (platform === 'wap') {
      return locale.toUpperCase();
    }

    return LANGUAGES[locale]?.name || locale.toUpperCase();
  }

  get showMyRequest () {
    return !this.hideMyRequests && this.isChatScreen && this.isLogin;
  }

  get hideBackButton () {
    const { forceHideBack, isActiveConversationSelected, isChatScreen, platform } = this;
    if (forceHideBack) return true;
    if (isActiveConversationSelected) return false;

    return (isChatScreen && platform !== 'wap');
  }

  get actionType () {
    if (this.isLogin) {
      return {
        msg: this.$t('global.my_requests'),
        type: ActionEnum.MyRequest,
      };
    }
    if (this.platform === 'web' || this.hideLoginButton) { // not login web
      return {
        msg: '',
        type: ActionEnum.NotLoginWeb,
      };
    }
    return {
      msg: this.t('header.register'),
      type: ActionEnum.Login,
    };
  }

  get enableMinimize () {
    return this.isInlive || this.platform === 'web' || this.isNative;
  }
  get enableEndChat () {
    if (this.platform === 'web') {
      return this.isInlive;
    }
    return true;
  }
  get isNative () {
    return this.platform === 'app' || this.platform === 'ios';
  }

  handleDot () {
    if (!this.showDropdown) {
      this.navHeight = this.$refs.nav.getBoundingClientRect().height;
      this.showDropdown = true;
      return;
    }
    this.showDropdown = false;
  }

  showChangeLanguage () {
    const dialog = this.$dialog({ componentBackground: 'transparent', content: <LanguageSelector onCloseDialog={() => dialog?.close()} /> });
  }

  private closeDropdown () {
    this.showDropdown = false;
  }

  private back () {
    this.showDropdown = false;

    analytics.trackClick({
      name: `${this.trackEventContext}${COMPONENT_EVENTS.HEADER_BACK}`,
      ...(this.ticketId ? { selection: this.ticketId } : {}),
    });

    if (this.backCallback) {
      this.backCallback();
      return;
    }
    this.$router.back();
  }

  async handleEndChat () {
    if (!this.enableEndChat) return;
    this.showDropdown = false;

    if (this.endChatCallback) {
      this.endChatCallback();
      return;
    }

    await syncLogs();

    if (this.platform) {
      sendToParent('CLOSE');
    } else {
      this.back();
    }
  }

  handleManageConsent () {
    this.showDropdown = false;
    this.showManageConsentModel = true;
  }

  closeManageConsent () {
    this.showManageConsentModel = false;
  }

  private clickAction () {
    if (this.actionType.type === ActionEnum.MyRequest) {
      emitOpenMyRequest(true);
    } else if (this.actionType.type === ActionEnum.Login) {
      sendToParent('LOGIN_POP');
    }
  }

  private handleMinimize () {
    this.showDropdown = false;
    if (!this.enableMinimize) return;
    Bridge.minimize();
  }
}
